export const noScheduledTransactionsCopy = 'Set up a recurring transaction to boost your savings over time.';

export const readOnlyTooltipCopy =
  'Only the owner(s) of this source account can edit or cancel this recurring transaction by logging in to their Betterment account.';
